import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=053c8bac&scoped=true"
import script from "./camera.vue?vue&type=script&lang=js"
export * from "./camera.vue?vue&type=script&lang=js"
import style0 from "./camera.vue?vue&type=style&index=0&id=053c8bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c8bac",
  null
  
)

export default component.exports